export const RECAPTCHA_SITE_KEY = '6LcgFCIsAAAAAOZX_kG4pqWtVX4HkhSa4n1hW3PI';
export const ASK_ANALYST_SUBMIT_URL = 'https://website-submission.psa-intelligence-418.workers.dev/api/submit';
